import { Injectable } from '@angular/core';
import { ClinicDocument } from '../../domain/models/clinic-document.model';
import { DocumentationDto } from '../dtos/documentation.dto';

@Injectable()
export class DocumentationMapper {
  public toDocument(dto: DocumentationDto): ClinicDocument {
    return {
      id: dto.Id,
      title: dto.Title,
      description: dto.Description,
      fileName: dto.FileName,
      contentType: dto.ContentType,
      sizeBytes: dto.SizeBytes,
      updatedAtUtc: dto.UpdatedAtUtc ? new Date(dto.UpdatedAtUtc) : null,
      isAvailable: dto.IsAvailable,
    };
  }

  public toDocuments(dtos: readonly DocumentationDto[]): readonly ClinicDocument[] {
    return dtos.map((dto) => this.toDocument(dto));
  }
}
